import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@core/services/api.service';
import { EntityApiService } from '@core/services/entity-api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable, firstValueFrom } from 'rxjs';
import { Tag, TagInfo, UserTag } from '../interfaces/tag.interface';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private readonly sellerService = inject(EntityApiService);
  private readonly _api = inject(ApiService);
  private readonly router = inject(Router);

  getAllTagsWithInfo(): Observable<TagInfo[]> {
    return this._api.request(ApiServiceHolder.tag.getAllTagsWithInfo());
  }

  getTagWithInfo(idTag: number): Observable<TagInfo> {
    return this._api.request(ApiServiceHolder.tag.get(idTag));
  }

  getTagWithInfoByDescription(idTag: string): Observable<TagInfo> {
    return this._api.request(ApiServiceHolder.tag.getByDescription(idTag));
  }
  getTagWithInfoByDescriptionCached(idTag: string): Observable<TagInfo> {
    return this._api.requestCached(
      ApiServiceHolder.tag.getByDescription(idTag)
    );
  }

  save(item: Tag): Observable<Tag[]> {
    return this._api.request(ApiServiceHolder.tag.save(item));
  }

  delete(idTag: number): Observable<unknown> {
    return this._api.request(ApiServiceHolder.tag.delete(idTag));
  }

  getAllUsersByTag(idTag: number): Observable<UserTag[]> {
    return this._api.request(ApiServiceHolder.tag.getAllUsersByTag(idTag));
  }

  isTagPage(): boolean {
    return this.router.url.includes('/tags/');
  }

  isSellerPage(): boolean {
    return this.router.url.includes('/seller/');
  }

  async isSpecialTagPage(): Promise<boolean> {
    try {
      if (this.isTagPage()) {
        const slug = this.router.url.split('/').pop();
        if (!slug) return false;
        const tag = await firstValueFrom(
          this.getTagWithInfoByDescriptionCached(slug)
        ).catch(() => null);
        return !!tag?.special;
      }

      if (this.isSellerPage()) {
        const idPart = this.router.url.split('/').pop();
        const id = idPart ? Number(idPart) : NaN;
        if (!Number.isFinite(id)) return false;
        const seller = (await firstValueFrom(
          this.sellerService.getLocalCachedBaseDataByPk(id)
        ).catch(() => null)) as { isAutonomous?: boolean } | null;
        return !!seller?.isAutonomous;
      }
      return false;
    } catch {
      return false; // swallow errors and treat as non-special
    }
  }
}
